<template>
  <div class="qty_adjuster">
    <button @click.prevent="adjust(-1)" :disabled="adjustDisabled(-1)" class="css_minus"><div class="sr-only">Decrease quantity</div></button>
    <div class="qty_adjuster_number">
      <label for="quantity-input" class="qty_adjuster_label visually-hidden">Quantity</label>
        <input id="quantity-input" type="number" :name="name" v-model="localVal" :min="min" :max="max" readonly :aria-label="`Current quantity: ${localVal}`"
        aria-live="polite">
    </div>
    <button @click.prevent="adjust(1)" :disabled="adjustDisabled(1)" class="css_plus"><div class="sr-only">Increase quantity</div></button>
  </div>
</template>

<script>
  // On change to debounced update function
  // Update function to return new value and set
  export default {
    name: 'qty_adjuster',
    props: ['name', 'value', 'min_prop', 'max_prop', 'onchange'],
    data() {
      return {
        localVal: this.value,
        timeout: null,
      }
    },
    computed: {
      min: function() { return typeof(this.min_prop) !== 'undefined' ? this.min_prop : null },
      max: function() { return typeof(this.max_prop) !== 'undefined' ? this.max_prop : null },
      hasMin: function() { return this.min !== null && typeof this.min !== 'undefined' },
      hasMax: function() { return this.max !== null && typeof this.max !== 'undefined' },
    },
    watch: {
      // Without this, quantity is not reactive from the core object.
      // However, just updating localVal whenever value changes will mean we interrupt the user changing the value with updates from older changes - e.g. changing quantity down, then up, with the update coming through sometime in-between.
      // So, we only update when everything is stable - localVal, what the user changes, is not out of sync with the existing value. It's an update in isolation from user activity, which should resolve within seconds anyway.
      // Whew.
      value(newValue, oldValue) {
        if (this.localVal === oldValue) {
          this.localVal = newValue;  
        }
      },
    },
    methods: {  
      adjust: function(increment) {
        const originalVal = this.localVal;
        let newValue = this.localVal + increment;
        if (this.hasMin) {
          newValue = Math.max(this.min, newValue);
        }
        if (this.hasMax) {
          newValue = Math.min(this.max, newValue);
        }
        this.localVal = newValue;

        // On error, revert input value to original
        const errorCallback = () => {
          this.localVal = originalVal;
        };

        this.debouncedOnChange(errorCallback);
      },
      adjustDisabled: function(increment) {
        const wouldValue = this.localVal + increment;

        // If it's already out of range, allow the user to adjust in the direction of the range.
        const outOfRangeButBetter = (this.hasMin && this.localVal < this.min && wouldValue > this.localVal) || (this.hasMax && this.localVal > this.max && wouldValue < this.localVal);
        if (outOfRangeButBetter) {
          return false;
        }

        return (this.hasMin && (wouldValue < this.min)) || (this.hasMax && (wouldValue > this.max));
      },
      debouncedOnChange: function(errorCallback) {
        const { onchange, localVal } = this;
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => onchange(localVal, errorCallback), 300);
      }
    },
  }

  // Handle user entering e and etc. if not readonly
</script>